//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import ProductTable from "@/pages/Hierarchies/Designation/components/ProductTable.vue";
import ProductTab from "@/pages/Hierarchies/Designation/components/ProductTab.vue";
import StoresTab from "@/pages/Hierarchies/Designation/components/StoresTab.vue";
import StoresTable from "@/pages/Hierarchies/Designation/components/StoresTable.vue";
import GeographyTable from "@/pages/Hierarchies/Designation/components/GeographyTable.vue";
import GeographyTab from "@/pages/Hierarchies/Designation/components/GeographyTab.vue";
import NielsenTable from "@/pages/Hierarchies/Designation/components/NielsenTable.vue";
import NielsenTab from "@/pages/Hierarchies/Designation/components/NielsenTab.vue";
import SalesForceTab from "@/pages/Hierarchies/Designation/components/SalesForceTab.vue";
import SalesForceTable from "@/pages/Hierarchies/Designation/components/SalesForceTable.vue";
import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "Hierarchies",
  components: {
    ProductTable,
    ProductTab,
    StoresTab,
    StoresTable,
    SalesForceTable,
    SalesForceTab,
    GeographyTab,
    GeographyTable,
    NielsenTable,
    NielsenTab,
  },
  mounted: function () {
    BackendServices.getAllProductHierarchyLevelElements().then(
      (result) => (this.tableData = result)
    );
  },
  data: () => ({
    createMode: false,
    productForm: true,
    storesForm: true,
    geographyForm: true,
    salesForceForm: true,
    filterState: null,
    product: {
      level_id: null,
      parent_id: null,
      name: null,
      level: {
        id: null,
        parent_id: null,
        name: null,
        type_id: null,
      },
      parent: {
        id: null,
        parent_id: null,
        name: null,
        level_id: null,
      },
    },
    stores: {
      level_id: null,
      parent_id: null,
      name: null,
    },
    salesForce: {
      level_id: null,
      parent_id: null,
      name: null,
    },
    geography: {
      level_id: null,
      parent_id: null,
      name: null,
    },
    nielsen: {
      id: null,
      name: null,
    },
    tableData: [],
    tableTab: "product",
    tab: "product",
    rightSidePane: false,
    isLoading: false,
  }),
  methods: {
    createNew: function () {
      this.createMode = true;
      this.rightSidePane = true;
      // this.productForm = false;
      // this.storesForm = false;
      // this.salesForceForm = false;
      (this.product = {
        level_id: null,
        parent_id: null,
        name: null,
      }),
        (this.stores = {
          level_id: null,
          parent_id: null,
          name: null,
        }),
        (this.salesForce = {
          level_id: null,
          parent_id: null,
          name: null,
        }),
        (this.geography = {
          level: undefined,
          level_id: null,
          name: "",
          parent: undefined,
          parent_id: null,
        }),
        (this.nielsen = {
          id: null,
          name: null,
        });
    },
    renderRightSide: function (event) {
      this.rightSidePane = true;
      if (this.tab === "product") {
        this.product = event;
      }
      if (this.tab === "stores") {
        this.stores = event;
      }
      if (this.tab === "sales-force") {
        this.salesForce = event;
      }
      if (this.tab === "geography") {
        this.geography = event;
      }
      if (this.tab === "nielsen") {
        this.nielsen = event;
      }
    },
    closeForm: function () {
      this.createMode = false;
      this.rightSidePane = false;
      this.product = {};
      this.stores = {};
      this.salesForce = {};
      this.geography = {};
      this.nielsen = {};
    },
    saveProduct: async function () {
      if (this.tab === "nielsen") {
        const response = await BackendServices.updateNielsenArea(this.nielsen);
        const changedElementIndex = this.tableData.findIndex(
          (e) => e.id === response.data.id
        );
        this.tableData[changedElementIndex].value = response.data.value;
        this.rightSidePane = false;
      }
      if (this.tab === "geography") {
        if (!this.createMode) {
          //update item
          const response =
            await BackendServices.updateGeographyHierarchyLevelElement(
              this.geography
            );
          const changedElementIndex = this.tableData.findIndex(
            (e) => e.id === response.data.id
          );
          const newParent = this.tableData.find(
            (e) => e.id === response.data.parent_id
          );
          this.tableData[changedElementIndex].parent_id =
            response.data.parent_id;
          this.tableData[changedElementIndex].parent = newParent;
          this.tableData[changedElementIndex].name = response.data.name;
          this.rightSidePane = false;
        } else {
          //create item
          const response =
            await BackendServices.createGeographyHierarchyLevelElement(
              this.geography
            );
          const newParent = this.tableData.find(
            (e) => e.id === response.data.parent_id
          );
          this.geography.parent = newParent;
          this.tableData.push(this.geography);
          this.rightSidePane = false;
        }
      }
      if (this.tab === "stores") {
        if (!this.createMode) {
          //update item
          const response =
            await BackendServices.updateStoreHierarchyLevelElement(this.stores);
          const changedElementIndex = this.tableData.findIndex(
            (e) => e.id === response.data.id
          );
          const newParent = this.tableData.find(
            (e) => e.id === response.data.parent_id
          );
          if (response.status === 200) {
            Feedback.success("Hierarquia modificada.");
            this.tableData[changedElementIndex].parent_id =
              response.data.parent_id;
            this.tableData[changedElementIndex].parent = newParent;
            this.tableData[changedElementIndex].name = response.data.name;
          } else {
            Feedback.error("Erro a modificar hierarquia.");
          }
          this.rightSidePane = false;
        } else {
          //create item
          const response =
            await BackendServices.createStoreHierarchyLevelElement(this.stores);
          const newParent = this.tableData.find(
            (e) => e.id === response.data.parent_id
          );
          if (response.status === 201) {
            Feedback.success("Hierarquia criada.");
            this.stores.parent = newParent;
            this.stores.parent_id = newParent.id;
            this.stores.id = response.data.id;
            this.tableData.push(this.stores);
          } else {
            Feedback.error("Erro a criar hierarquia.");
          }
          this.rightSidePane = false;
        }
      }

      if (this.tab === "product") {
        if (!this.createMode) {
          //update item
          const response =
            await BackendServices.updateProductHierarchyLevelElement(
              this.product
            );
          const changedElementIndex = this.tableData.findIndex(
            (e) => e.id === response.data.id
          );
          const newParent = this.tableData.find(
            (e) => e.id === response.data.parent_id
          );

          if (response.status === 200) {
            Feedback.success("Hierarquia modificada.");
            this.tableData[changedElementIndex].parent_id =
              response.data.parent_id;
            this.tableData[changedElementIndex].parent = newParent;
            this.tableData[changedElementIndex].name = response.data.name;
          } else {
            Feedback.error("Erro a modificar hierarquia.");
          }
          this.rightSidePane = false;
        } else {
          //create item
          const response =
            await BackendServices.createProductHierarchyLevelElement(
              this.product
            );
          const newParent = this.tableData.find(
            (e) => e.id === response.data.parent_id
          );
          const levelElement = this.tableData.find(
            (e) => e.level_id === response.data.level_id
          );
          if (response.status === 201) {
            Feedback.success("Hierarquia criada.");
            this.product.level = levelElement.level;
            this.product.parent = newParent;
            this.product.parent_id = newParent.id;
            this.product.id = response.data.id;
            this.tableData.push(this.product);
          } else {
            Feedback.error("Erro a criar hierarquia.");
          }
          this.rightSidePane = false;
        }
      }
      this.createMode = false;
    },
    removeProduct: async function (event) {
      if (this.tab === "geography") {
        try {
          await BackendServices.deleteGeographyHierarchyLevelElement(event);
          const changedElementIndex = this.tableData.findIndex(
            (e) => e.id === event.id
          );
          this.tableData.splice(changedElementIndex, 1);
          //success toast can be called here
        } catch (err) {
          if (err.response.status === 422) {
            //future use of error toast > this operation only fails when there's other entities referencing the selected element
          }
        }
      }
      this.rightSidePane = false;
    },
  },
  watch: {
    tableTab: {
      immediate: true,
      deep: true,
      handler: function () {
        this.rightSidePane = false;
        this.isLoading = true;
        this.tableData = [];

        if (this.tableTab === "product") {
          BackendServices.getAllProductHierarchyLevelElements().then(
            (result) => {
              this.tableData = result;
              this.isLoading = false;
            }
          );
        }

        if (this.tableTab === "stores") {
          BackendServices.getAllStoreHierarchyLevelElements().then((result) => {
            this.tableData = result;
            this.isLoading = false;
          });
        }

        if (this.tableTab === "geography") {
          BackendServices.getAllGeographyHierarchyLevelElements().then(
            (response) => {
              this.tableData = response;
              this.isLoading = false;
            }
          );
        }

        if (this.tableTab === "sales-force") {
          BackendServices.getSalesforceHierarchyLevelElements().then(
            (response) => {
              this.tableData = response.data;
              this.isLoading = false;
            }
          );
        }

        if (this.tableTab === "nielsen") {
          BackendServices.getNielsenAreas().then((response) => {
            this.tableData = response.data;
            this.isLoading = false;
          });
        }
      },
    },
  },
};
